import Button from 'content-components/_Primatives/Button'
import style from './style.scss'

type Props = {
  submitButtonText: string
  onClose: () => void
  closeButtonLabelText: string
}

function FormButtons({
  submitButtonText,
  onClose,
  closeButtonLabelText,
}: Props) {
  return (
    <div className={style.wrapper}>
      <Button
        className={style.submitButton}
        type='submit'
        variant='primaryBlue'
      >
        {submitButtonText}
      </Button>
      <Button
        aria-label={closeButtonLabelText}
        className={style.closeButton}
        type='button'
        variant='primaryBlue'
        onClick={onClose}
      >
        X
      </Button>
    </div>
  )
}

export default FormButtons
